module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "home"
    }
  }, [_c('v-header', {
    attrs: {
      "ismenu": _vm.ismenu
    }
  }), _vm._v(" "), _c('div', {
    class: {
      container: _vm.ismenu
    }
  }, [(_vm.ismenu) ? _c('v-breadcrumb') : _vm._e(), _vm._v(" "), _c('router-view')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4309e776"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 661
// module chunks = 1